import { createSelector } from 'reselect';

export const getLogin = state => state.login;

export const getPersonId = createSelector(getLogin, loginData => {
  if (loginData) {
    return loginData.personId;
  }
});

export const getUserVehicles = createSelector(
  getLogin,
  ({ vehicles }) => vehicles || []
);

export const getUserVehicleByVIN = createSelector(
  getUserVehicles,
  userVehicles => vin => {
    if (vin) {
      return userVehicles.find(vehicle => vehicle.vin === vin) || null;
    }
    return null;
  }
);



// WEBPACK FOOTER //
// ./src/store/reducers/login/selectors.js